var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 .166A5.835 5.835 0 00.167 5.999 5.835 5.835 0 006 11.833a5.836 5.836 0 005.834-5.834A5.835 5.835 0 006 .166zm.584 8.75H5.417V7.749h1.167v1.167zm0-2.333H5.417v-3.5h1.167v3.5z",
    fill: "#FEE8E5"
  })));
}
export default SvgExclamation;